import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentPdf = () => {
  return (
    <g>
      <path d="M14.4.2H5.1c-.2 0-.4.1-.5.2L1.1 3.9c-.1.1-.2.3-.2.5V15c0 .4.3.7.7.7h12.7c.4 0 .7-.3.7-.7V.9c0-.4-.3-.7-.6-.7zm-9.5 2v2h-2l2-2zm8.7 12.1H2.4V5.6h3.2c.4 0 .7-.3.7-.7V1.7h7.3v12.6z" />
      <path d="M5.5 11.5v.8h-.6V9.9h1c.6 0 .9.3.9.8s-.4.8-.9.8h-.4zm.3-1.1h-.3v.7h.3c.3 0 .4-.1.4-.3 0-.3-.1-.4-.4-.4zM7.1 9.9H8c.7 0 1.2.4 1.2 1.2 0 .8-.5 1.2-1.2 1.2h-.9V9.9zm.6 1.9H8c.4 0 .6-.2.6-.7 0-.5-.3-.7-.6-.7h-.3v1.4zM9.6 12.3V9.9h1.7v.5h-1.1v.6h.9v.5h-.9v.9h-.6z" />
    </g>
  );
};

export default withIcon(IconDocumentPdf);
